export default {
  title: {
    add: 'Dodaj skrypt',
    update: 'Aktualizuj skrypt',
  },
  form: {
    strategy: {
      label: 'Strategia',
      placeholder: 'Wybierz strategię',
    },
    source: {
      label: 'Źródło (src)',
      placeholder: 'Wprowadź źródło',
    },
    async: {
      label: 'Async',
      placeholder: 'Wybierz Async',
    },
    content: {
      label: 'Zawartość',
      placeholder: 'Wprowadź zawartość',
    },
  },
  alert: {
    use_case: 'Przypadek użycia',
  },
  buttons: {
    save: 'Zapisz',
  },
};
